var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 30.4994C61 13.6547 47.3447 -0.00056839 30.5 -0.00056839C13.6553 -0.00056839 0 13.6547 0 30.4994C0 45.7229 11.1534 58.3408 25.7344 60.6289V39.3158H17.9902V30.4994H25.7344V23.7799C25.7344 16.1358 30.2878 11.9135 37.2547 11.9135C40.5916 11.9135 44.082 12.5092 44.082 12.5092V20.0151H40.236C36.4472 20.0151 35.2656 22.3661 35.2656 24.7781V30.4994H43.7246L42.3724 39.3158H35.2656V60.6289C49.8466 58.3408 61 45.7229 61 30.4994Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3724 39.3164L43.7246 30.5H35.2656V24.7787C35.2656 22.3667 36.4472 20.0156 40.2361 20.0156H44.082V12.5098C44.082 12.5098 40.5916 11.9141 37.2547 11.9141C30.2878 11.9141 25.7344 16.1364 25.7344 23.7805V30.5H17.9902V39.3164H25.7344V60.6295C27.2872 60.8731 28.8787 61 30.5 61C32.1213 61 33.7128 60.8731 35.2656 60.6295V39.3164H42.3724Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.ea7d720e0d7596a8592b04a701effe50.svg";
export { ForwardRef as ReactComponent };